import { Routes } from '@/app/routes'

// Roots whose layouts must outlive navigation between their own paths: the
// agent chat its /agent → /agent/<runId> URL swap, and the task hub's rail
// moving between the tasks it opens.
const SHARED_SCOPE_ROOTS = [Routes.Agent.root, Routes.FixedIncomeHub.root]

// The key for a subtree that remounts on navigation.
export function routeScope(pathname: string): string {
  const sharedRoot = SHARED_SCOPE_ROOTS.find(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  )
  return sharedRoot ?? pathname
}
